import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: 'ngx-icon-column',
  template: `
    <div class="d-flex align-items-center justify-content-center">
      <img *ngIf="params?.value" [src]="'data:image/jpeg;base64,' + params.value" width="16" height="16" />
    </div>
  `
})
export class IconColumnComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;

  constructor() {}

  refresh(params: ICellRendererParams) {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

}